var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71003 22.1702H0V11.0054H7.71003V22.1702ZM0.724625 21.4452H6.9854V11.7304H0.724625V21.4452Z",
    fill: "#233A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8546 22.17H10.1445V6.98877H17.8546V22.17ZM10.8692 21.445H17.1299V7.71376H10.8692V21.445Z",
    fill: "#233A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 22.1701H20.29V0H28.0001V22.1701ZM21.0147 21.4451H27.2754V0.724986H21.0147V21.4451Z",
    fill: "#233A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14524 13.3247H0.493164V14.0497H7.14524V13.3247Z",
    fill: "#233A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.319 9.4104H10.667V10.1354H17.319V9.4104Z",
    fill: "#233A80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5647 2.84155H20.9126V3.56654H27.5647V2.84155Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup20);
export default __webpack_public_path__ + "static/media/Group20.13a37f8eb70878ea17e12ffcdc66cba8.svg";
export { ForwardRef as ReactComponent };